<div class="outline-editor-butt-select flex flex-row space-x-2 items-center">
  <mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }" class="flex-1">
    <mat-label i18n>Облицовка</mat-label>
    <mat-select [disabled]="disabled || !editable" [(ngModel)]="_butt" (selectionChange)="onButtChange()">
      <mat-option i18n [value]="undefined">Нет</mat-option>
      <mat-option *ngFor="let item of butts" [value]="item">
        <p class="text-truncate">{{ item.sign }}</p>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <button
    class="mb-4"
    [disabled]="disabled || !editable"
    mat-icon-button
    data-testid="angleFacadeMaterialButton"
    (click)="openMaterialBaseDialog()"
    i18b-matTooltip
    matTooltip="Изменить облицовку">
    <mat-icon>settings</mat-icon>
  </button>
</div>
